import {
  Button,
  ButtonColor,
  ButtonWidth,
} from '@leland-dev/leland-ui-library';
import Link from 'next/link';
import React, { type ReactNode } from 'react';

import { type Scalars } from '../../__generated-gql-types__/globalTypes';
import {
  CoachingSessionUrgencyEnum,
  getCoachingSessionMeetingUrl,
  useCoachingSessionTimeRemaining,
} from '../../utils/coaching-session';

interface CountDownButtonProps {
  date: number;
  sessionId: Scalars['CoachingSessionUrn']['output'];
  blockedStateTooltip?: ReactNode;
  isFreeEvent: Possible<boolean>;
}

const CountDownButton: React.FC<CountDownButtonProps> = ({
  date,
  sessionId,
  blockedStateTooltip,
  isFreeEvent,
}) => {
  const { urgency, remainingTime } = useCoachingSessionTimeRemaining({
    startDate: date,
  });

  const text =
    urgency === CoachingSessionUrgencyEnum.NOW ||
    urgency === CoachingSessionUrgencyEnum.UPCOMING
      ? isFreeEvent
        ? 'Join event'
        : 'Join class'
      : `Join here in ${remainingTime}`;

  const blocked = !!blockedStateTooltip;

  return (
    <Link
      className="w-full"
      href={getCoachingSessionMeetingUrl(sessionId)}
      id="class_page--join_here_countdown"
    >
      <Button
        label={text}
        buttonColor={
          urgency === CoachingSessionUrgencyEnum.NOW ||
          urgency === CoachingSessionUrgencyEnum.UPCOMING
            ? ButtonColor.PRIMARY
            : ButtonColor.GRAY
        }
        width={ButtonWidth.FULL}
        disabled={
          (urgency !== CoachingSessionUrgencyEnum.NOW &&
            urgency !== CoachingSessionUrgencyEnum.UPCOMING) ||
          blocked
        }
        tooltipContent={blockedStateTooltip}
      />
    </Link>
  );
};

export default CountDownButton;
